import styles from './toolbar-separator.module.scss';

export function ToolbarSeparator() {
  return <div className={styles.separator}></div>;
}
